import { usePopupsManager } from '@funtech-int/web-toolkit';
import { useMemo } from 'react';

import {
    ContentModalHandler,
    createPaymentPopupHandler,
    createPopupHandler,
    ModalHandler,
    ToastHandler,
} from '../lib/popups';

export function useToast(): ToastHandler {
    const popups = usePopupsManager();

    return useMemo(() => createPopupHandler(popups, 'toast'), [popups]);
}

export function useModal(): ModalHandler {
    const popups = usePopupsManager();

    return useMemo(() => createPopupHandler(popups, 'modal'), [popups]);
}

export function useContentModal(): ContentModalHandler {
    const popups = usePopupsManager();

    return useMemo(() => createPopupHandler(popups, 'contentModal'), [popups]);
}

export function usePaymentWidgetModal() {
    const popups = usePopupsManager();

    return useMemo(() => createPaymentPopupHandler(popups), [popups]);
}
